import React from 'react';
import { Col, Row } from 'antd';
import { I18n } from '@aws-amplify/core';
import type { ColumnsType } from 'antd/lib/table';

import type { BeraResultCycleSummary, BeraResultHighestRPNScores, BeraResultRPNScoresByStepKey } from '@/types/Bera';
import { ScoreTable } from '@/components/views/BeraJob/Results/components/ScoreTable';

import { Accordion } from '../Accordion';
import { HighestRpnTable, Subtitle } from './styles';

const BLOCK_GUTTER = 24;
const FIRST_POSITION = 1;

interface BeraResultAccordionProps {
	cycleSummary: BeraResultCycleSummary;
	highestRpnScores: BeraResultHighestRPNScores;
	open: boolean;
	onToggle: () => void;
}

function renderPosition(_value: unknown, _record: BeraResultRPNScoresByStepKey, index: number): number {
	const result = index + FIRST_POSITION;

	return result;
}

function renderRiskFactor(description: string): string {
	const result = I18n.get(description);

	return result;
}

function buildColumns(): ColumnsType<BeraResultRPNScoresByStepKey> {
	const columns: ColumnsType<BeraResultRPNScoresByStepKey> = [
		{ title: I18n.get('Position'), key: 'position', render: renderPosition },
		{ title: I18n.get('TLID'), dataIndex: 'task_name', key: 'task_name', ellipsis: true },
		{
			title: I18n.get('Risk factor'),
			dataIndex: 'step_key_description',
			key: 'step_key_description',
			ellipsis: true,
			render: renderRiskFactor
		},
		{ title: I18n.get('RPN'), dataIndex: 'rpn', key: 'rpn' }
	];

	return columns;
}

export function BeraResultAccordion({
	cycleSummary,
	highestRpnScores,
	open,
	onToggle
}: Readonly<BeraResultAccordionProps>): JSX.Element {
	const columns = buildColumns();

	return (
		<Accordion title={I18n.get('B.E.R.A. Result')} open={open} onToggle={onToggle}>
			<Row gutter={[0, BLOCK_GUTTER]}>
				<Col span={24}>
					<Subtitle>{I18n.get('Cycle summary')}</Subtitle>
				</Col>
				<Col span={24}>
					<ScoreTable cycleSummary={cycleSummary} isENS={false} />
				</Col>
				<Col span={24}>
					<Subtitle>{I18n.get('Five highest RPNs')}</Subtitle>
				</Col>
				<Col span={24}>
					<HighestRpnTable
						rowKey="id"
						pagination={false}
						columns={columns}
						dataSource={highestRpnScores?.by_step_key ?? []}
					/>
				</Col>
			</Row>
		</Accordion>
	);
}
